module.exports = __webpack_public_path__ + "img/72.a05c768d.jpg";